import type { WordPairStimulus } from "./schemas";
const stimuliListPractice1 = [
  {
    stimulus: "dog",
    prompt: "cat",
    difficultyLevel: 1,
    language: "en",
    relation: "related",
  },
  {
    stimulus: "dog",
    prompt: "window",
    difficultyLevel: 2,
    language: "en",
    relation: "unrelated",
  },
  {
    stimulus: "dog",
    prompt: "puppy",
    difficultyLevel: 3,
    language: "en",
    relation: "related",
  },
  {
    stimulus: "dog",
    prompt: "pencil",
    difficultyLevel: 4,
    language: "en",
    relation: "unrelated",
  },
  {
    stimulus: "dog",
    prompt: "bark",
    difficultyLevel: 5,
    language: "en",
    relation: "related",
  },
  {
    stimulus: "dog",
    prompt: "cloud",
    difficultyLevel: 6,
    language: "en",
    relation: "unrelated",
  },
  {
    stimulus: "dog",
    prompt: "leash",
    difficultyLevel: 7,
    language: "en",
    relation: "related",
  },
  {
    stimulus: "dog",
    prompt: "guitar",
    difficultyLevel: 8,
    language: "en",
    relation: "unrelated",
  },
  {
    stimulus: "dog",
    prompt: "kennel",
    difficultyLevel: 9,
    language: "en",
    relation: "related",
  },
  {
    stimulus: "maison",
    prompt: "voiture",
    difficultyLevel: 1,
    language: "fr",
    relation: "unrelated",
  },
  {
    stimulus: "maison",
    prompt: "toit",
    difficultyLevel: 2,
    language: "fr",
    relation: "related",
  },
  {
    stimulus: "maison",
    prompt: "fleur",
    difficultyLevel: 3,
    language: "fr",
    relation: "unrelated",
  },
  {
    stimulus: "maison",
    prompt: "fenêtre",
    difficultyLevel: 4,
    language: "fr",
    relation: "related",
  },
  {
    stimulus: "maison",
    prompt: "livre",
    difficultyLevel: 5,
    language: "fr",
    relation: "unrelated",
  },
  {
    stimulus: "maison",
    prompt: "porte",
    difficultyLevel: 6,
    language: "fr",
    relation: "related",
  },
  {
    stimulus: "maison",
    prompt: "crayon",
    difficultyLevel: 7,
    language: "fr",
    relation: "unrelated",
  },
  {
    stimulus: "maison",
    prompt: "chambre",
    difficultyLevel: 8,
    language: "fr",
    relation: "related",
  },
  {
    stimulus: "maison",
    prompt: "soleil",
    difficultyLevel: 9,
    language: "fr",
    relation: "unrelated",
  },
] as WordPairStimulus[];

export { stimuliListPractice1 };
